import { IBooking, IBookingQuery } from '../interfaces'
import { useRef, useState } from 'react'
import { useBookingServices } from 'services'

const useSearchBooking = () => {
  const [bookings, setBookings] = useState<Array<IBooking>>([])
  const [loading, setLoading] = useState(false)
  const BOOKING_QUERY_DEFAULT: IBookingQuery = {
    query: {},
    limit: 20,
    offset: 0,
    order_by: 'created_at',
    asc: true
  }
  const queryRef = useRef({ ...BOOKING_QUERY_DEFAULT })

  const { searchBooking } = useBookingServices()
  const handleSearchBooking = (query?: IBookingQuery) => {
    setLoading(true)
    queryRef.current = { ...queryRef.current, ...query }
    searchBooking(queryRef.current)
      .then((res) => {
        if (res?._successfully) {
          setBookings(res?.data?.bookings)
        }
      })
      .finally(() => setLoading(false))
  }

  return { bookings, loading, searchBookings: handleSearchBooking }
}

export default useSearchBooking
